import { UserId } from '../Domain'
import {
  CommandParams,
  useCommandRequest
} from '@komune-io/g2-utils'
import { usePlatformRequest } from '../../Organization/Api/useOrganizationRequest'

export interface UserDisableCommand {
  id: UserId
  disabledBy?: UserId
  anonymize: Boolean
  attributes?: Record<string, string>
}

export interface UserDisabledEvent {
  id: UserId
  userIds: string[]
}

export const useUserDisable = (
  params: CommandParams<UserDisableCommand, UserDisabledEvent>
) => {
  const requestProps = usePlatformRequest()
  return useCommandRequest<UserDisableCommand, UserDisabledEvent>(
    'userDisable',
    requestProps,
    params
  )
}
